<template>
  <div class="dropdown-menu" v-if="isNotEmptySlot">
    <div class="dropdown-menu__dots" :class="dotsClass" @click="toggleDropdownMenu" tabindex="-1" @blur="closeDropdownModal">
      <span></span>
    </div>

    <transition name="fade" v-if="!isMobile">
      <div v-if="isOpen" class="dropdown-menu__items" :class="{ 'show-top': showItemsTop }" :style="dropdownStyle">
        <slot name="dropdownItems" />
        <slot />
      </div>
    </transition>

    <BaseModal
      v-else-if="dropdownIsModal === 'dropdown-settings'"
      hidden-close-btn
      class="modal-dropdown-settings"
      @close="closeModal"
    >
      <slot />
    </BaseModal>
  </div>
</template>

<script>

import { mapState } from 'vuex'
import BaseModal from '@/components/ui/Modal/BaseModal.vue'

export default {
  name: 'DropdownMenu',
  components: {
    BaseModal
  },
  props: {
    dropdownIsModal: {
      type: [Boolean, String],
      default: false
    },
    // Для вывода модалки вверх относительно кнопки
    showItemsTop: {
      type: Boolean,
      default: false
    },
    dotsClass: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isOpen: false,
      isNotEmptySlot: true,
      dropdownStyle: {}
    }
  },
  computed: {
    ...mapState('mobile', {
      isMobile: 'isMobile'
    })
  },
  created () {
    this.isNotEmptySlot = !!this.$slots.default?.[0]
  },
  beforeUpdate () {
    this.isNotEmptySlot = !!this.$slots.default?.[0]
  },
  methods: {
    updateDropdownPosition () {
      if (!this.$el) return

      const rect = this.$el.getBoundingClientRect()

      this.dropdownStyle = {
        top: `${rect.bottom}px`,
        right: `${document.documentElement.clientWidth - rect.right}px`
      }
      if (this.showItemsTop) {
        this.dropdownStyle = {
          ...this.dropdownStyle,
          top: `${rect.top}px`,
          transform: 'translateY(-100%)'
        }
      }
    },
    toggleDropdownMenu () {
      if (!this.isMobile) {
        this.isOpen = !this.isOpen

        if (this.isOpen) {
          this.updateDropdownPosition()
          window.addEventListener('scroll', this.updateDropdownPosition, true)
          window.addEventListener('resize', this.updateDropdownPosition)
        } else {
          window.removeEventListener('scroll', this.updateDropdownPosition, true)
          window.removeEventListener('resize', this.updateDropdownPosition)
        }
      } else {
        this.$emit('openModal', 'dropdown-settings')
      }
    },
    closeDropdownModal () {
      this.isOpen = false
      window.removeEventListener('scroll', this.updateDropdownPosition, true)
      window.removeEventListener('resize', this.updateDropdownPosition)
    },
    closeModal () {
      this.$emit('closeModal')
    }
  }
}
</script>
